<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    :title="`${DocumentStatus}零星费用报销单`"
    width="80%"
    height="90%"
    @show="showModal"
  >
    <div class="formContainer">
      <div class="leftFormContainer">
        <el-form ref="FormRef" size="mini" :rules="rules" :model="form" :disabled="isDisabled">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="公司" prop="company">
                <el-select clearable v-model="form.company" placeholder="选择">
                  <el-option
                    v-for="i of ComBoxItems.company"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="报销日期" prop="r_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.r_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="报销人" prop="users_name">
                <!-- <el-input placeholder="关联" v-model="form.users_name" v-readonly> </el-input> -->
                <el-input
                  placeholder="选择"
                  v-model="form.users_name"
                  v-readonly
                  :clearable="$store.state.userInfo.authority.includes('财务审核')"
                >
                  <i
                    style="cursor: pointer;"
                    v-if="$store.state.userInfo.authority.includes('财务审核')"
                    slot="suffix"
                    class="el-icon-search"
                    @click="handleSelect"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="粘贴单据(张)" prop="document_count">
                <el-input placeholder="输入" v-model="form.document_count" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="金额" prop="amout">
                <el-input placeholder="输入" v-model="form.amout" v-money:2="showMoney" />
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="大写金额">
                <el-input placeholder="自动计算" v-readonly :value="convertCurrency(form.amout)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="事由" prop="subject_matter">
                <el-input type="textarea" :rows="5" placeholder="输入" v-model="form.subject_matter" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="rightFormContainer">
        <FileList :ID="id" :isDisabled="isDisabled" ref="FileListRef" vuePath="Sporadic" />
      </div>
    </div>

    <!-- 页脚按钮 -->
    <DetailModalBtnVue
      ref="DetailModalBtnVueRef"
      menuPath="Sporadic"
      :parentData="this"
      @handleClick="handleClickBtn"
    />

    <!-- 财务审批 -->
    <FinancialReviewModalVue ref="FinancialReviewModalVueRef" @sureHandler="sureFinancialReview" />

    <!-- 选择用户 -->
    <EmployeeSelect ref="EmployeeSelectRef" :isMultiple="false" @sureBackPerson="sureBackPerson" />
  </vxe-modal>
</template>
<script>
import FileList from '@/components/Form/FileList.vue'
import DetailModalBtnVue from '@/components/common/DetailModalBtn.vue'
import FinancialReviewModalVue from '../../components/common/ReviewModal.vue'
import EmployeeSelect from '../../components/Modal/Employee/EmployeeSelect.vue'
import { getState } from '../../utils/state'
import { handlePrint } from './print'

export default {
  components: {
    FileList,
    DetailModalBtnVue,
    FinancialReviewModalVue,
    EmployeeSelect
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        id: '',
        users_name: '',
        creator_id: '',
        creator: '',
        createTime: '',
        manager_review: false,
        document_status: 0,
        cmbDocument_status: '',
        r_date: '',
        users_id: '',
        document_count: '',
        amout: '',
        subject_matter: '',
        company: '',
        last_modify_time: ''
      },
      rules: {
        company: [{ required: true, message: '请选择公司', trigger: 'change' }],
        r_date: [{ required: true, message: '请输入报销日期', trigger: 'change' }],
        users_name: [{ required: true, message: '请选择报销人', trigger: 'change' }],
        document_count: [
          { required: true, message: '请输入粘贴单据', trigger: 'change' },
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.greaterThanZero,
            trigger: 'change'
          }
        ],
        amout: [
          { required: true, message: '请输入金额', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 8,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        subject_matter: [
          { required: true, message: '请输入事由', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {
        company: [
          {
            name: '福州远控',
            value: '福州远控'
          },
          {
            name: '福建远控',
            value: '福建远控'
          },
          {
            name: '中心',
            value: '中心'
          },
          {
            name: '公司',
            value: '公司'
          }
        ]
      },
      formVisible: false,

      showMoney: true,
      // 是否禁用编辑
      isDisabled: false
    }
  },
  methods: {
    handlePrint,
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 领导/总经理审批
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 财务审核通过
    async sureFinancialReview(flag) {
      const success = await this.sureReview(flag)
      if (success) {
        this.$message.success('操作成功')
        this.$refs.FinancialReviewModalVueRef.formVisible = false

        this.$emit('updateData')
        this.BindText()
      }
    },
    // 财务审核 - new
    handleFinancialReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/petty_expense_reimbursement_form/audit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/petty_expense_reimbursement_form/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/finance/petty_expense_reimbursement_form/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'financialReview':
          // this.$refs.FinancialReviewModalVueRef.formVisible = true
          this.handleFinancialReview()
          break
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
        case 'printPreview':
          this.handlePrint(this.form)
          break
      }
    },
    // 打开模态窗
    openModal(id = 0) {
      this.id = id

      if (!this.id) {
        this.form = {
          id: '',
          document_status: 0,
          manager_review: false,
          company: '',
          r_date: '',
          r_user_id: '',
          users_name: '',
          document_count: '',
          amout: '',
          subject_matter: ''
        }
      }

      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    async validEnter() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 获取数据
    async BindText() {
      const that = this
      if (that.id > 0) {
        const { data: res } = await that.$http.get('/finance/petty_expense_reimbursement_form', {
          params: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.form = res.data
        }
      } else {
        this.form.r_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        // 用户信息赋值
        this.form.users_id = this.$store.state.userInfo.userId
        this.form.users_name = this.$store.state.userInfo.name
        // 粘贴单据
        this.form.document_count = 1

        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
      that.$nextTick(() => {
        that.$refs.FormRef.clearValidate()

        if (this.form.document_status !== 0 || this.form.creator_id !== this.$store.state.userInfo.userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      })
    },
    // 新增
    async add() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      const { data: res } = await that.$http.post('/finance/petty_expense_reimbursement_form', form)
      if (res.isSuccess) {
        that.id = res.data
        that.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        that.BindText()
        that.$message.success(that.messageConfig.save.success)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      const that = this
      let form = { ...that.form }
      form = that.removeObjectNull(form)
      const { data: res } = await that.$http.put('/finance/petty_expense_reimbursement_form', form)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.save.success)
        that.$emit('updateData')

        that.BindText()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/finance/petty_expense_reimbursement_form', {
          data: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.$message.success(that.messageConfig.del.success)
          that.formVisible = false

          that.$emit('updateData')
        } else {
          that.$message.error(res.errorMessage)
        }
      })
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      // this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    showModal() {
      this.BindText()

      this.getFileList()
    },
    // 选择人员
    handleSelect() {
      if (!this.isDisabled) {
        this.$refs.EmployeeSelectRef.openModal(this.form.users_name)
      }
    },
    // 选择完成后
    sureBackPerson(person) {
      this.form.users_name = person
    }
  },
  computed: {
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form)}] `
    }
  }
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  height: 100%;
  width: calc(100% - @rightFormContainerWidth);

  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: @rightFormContainerWidth;
  box-sizing: border-box;
  padding: 0 10px;
}
</style>
